// A calendar day (an expiry, a bill date) is a "date only" value. Everywhere on screen it is a Date at LOCAL midnight,
// which is what the PrimeReact Calendar produces, and on the wire it is YYYY-MM-DD. Building that text with
// toISOString() converts to UTC first, which moves the day back by one in time zones ahead of UTC (Sri Lanka, UTC+5:30).

const pad = (n) => String(n).padStart(2, '0');

/** Date at local midnight -> 'YYYY-MM-DD' (no time zone shift). */
export const localYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** 'YYYY-MM-DD' (or an ISO string) -> Date at local midnight, or null. */
export const ymdToDate = (s) => {
  if (!s) return null;
  if (s instanceof Date) return Number.isNaN(s.getTime()) ? null : s;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s));
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return Number.isNaN(d.getTime()) ? null : d;
};

/** A Date or a date string -> 'YYYY-MM-DD', or '' when empty/invalid. */
export const toYmd = (v) => {
  if (!v) return '';
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? '' : localYmd(v);
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(String(v));
  return m ? m[1] : '';
};
